<template>

	<div class="select-settings float-right clearfix mx-auto">
	<div class="float-right m-1">
	<b-button variant="secondary" ref="selectSettingsButton" size="sm" @click="toggle()"><i class="fa fa-cog" aria-hidden="true" title="Settings"></i></b-button>
	</div>
	<select-currency ref="selectCurrencyRef" v-bind:class="[showButtons ? 'd-inline' : 'd-none', 'float-left m-1']" />
	<select-exchanges ref="selectExchangesRef" v-bind:class="[showButtons ? 'd-inline' : 'd-none', 'float-left m-1']" />
	</div>

</template>

<style>

</style>


<script>
import SelectCurrency from '@/components/SelectCurrency';
import SelectExchanges from '@/components/SelectExchanges';

export default {
  name: '',
  components: {
	  'select-currency': SelectCurrency,
	  'select-exchanges': SelectExchanges
  },

  data () {
	  return {
		  'showButtons': false
	  }
  },

  mounted: function () {

		this.$nextTick(function () {
			// Code that will run only after the
			// entire view has been rendered

			this.setInitial();

		});
	},

  methods: {
	  toggle() {

		  // toggle show buttons
		  this.showButtons = this.showButtons? false : true;
	  },

	  setInitial() {
		  // Show settings buttons if user has not updated their settings
		  if ((this.$refs.selectCurrencyRef.hasSavedCurrency() === false) || (this.$refs.selectExchangesRef.hasSavedExchanges() === false))  {
			  this.showButtons = true;
		  }
	  }
  }

}
</script>





// WEBPACK FOOTER //
// src/components/SelectSettings.vue